import { Info } from "lucide-react";

export const AuthDisclaimer = ({ className = "" }) => (
  <div
    data-testid="auth-disclaimer"
    className={`mt-5 flex items-start gap-2 rounded-lg border border-slate-700/70 bg-slate-950/60 px-3 py-2.5 ${className}`}
  >
    <Info className="w-3.5 h-3.5 text-slate-500 mt-0.5 shrink-0" />
    <p className="text-[11px] leading-relaxed text-slate-500">
      Sama Jaamu est un service privé et indépendant. Cette application n'est ni
      affiliée, ni autorisée, ni approuvée par aucune institution gouvernementale.
    </p>
  </div>
);

export default AuthDisclaimer;
